import React from 'react';
import { cn } from './cn';

// shadcn-tarzı rozet. variant ile hazır stiller; renk ile (hex) serbest ton.
const VARYANT = {
  default: 'bg-gray-100 text-gray-700 border border-gray-200',
  primary: 'bg-blue-50 text-blue-700 border border-blue-200',
  soft: 'border', // renk prop'u ile inline ton
  outline: 'border border-gray-300 text-gray-600',
  muted: 'bg-gray-50 text-gray-400 border border-gray-200',
};

export function Badge({ variant = 'default', renk, className, style, children, ...props }) {
  // renk verilirse yumuşak dolgu + okunur metin (inline style).
  const renkStyle = renk
    ? { backgroundColor: `${renk}14`, color: renk, borderColor: `${renk}33`, ...style }
    : style;
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full font-medium whitespace-nowrap',
        'px-2 py-0.5 text-[11px] leading-none',
        renk ? 'border' : VARYANT[variant],
        className
      )}
      style={renkStyle}
      {...props}
    >
      {children}
    </span>
  );
}

export default Badge;
